import { Component } from '@angular/core';
import { ActionCoMissionGroup, ActionCoMissionQuestion } from '../../../models';
import { MissionCalculatorService } from '../mission-calculator.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-calculateur-view',
  templateUrl: './calculator-view.component.html',
  styleUrls: ['./calculator-view.component.css', '../mission-calculator.component.css']
})

export class CalculatorViewComponent {

  constructor(
    public calculatorService: MissionCalculatorService
  ) { }
}



